import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type Message = {
  id: string
  content: string
  imageUrl: string | null
  author: {
    id: string
    avatarUrl: string | null
    fullName: string
  }
  createdAt: string
  updatedAt: string
}

const fetchMessages = async (
  conversationId: string,
  { pageParam = '0' }: FetchParams
): Promise<PaginatedResponse<Message>> => {
  const url = `/conversations/${conversationId}/messages?page=${pageParam}`
  
  const { data } = await api.get<PaginatedResponse<Message>>(url)
  return data
}

// Nothing tells the app that the other person wrote (a push is not always
// sent, nor received): while the conversation is in front, check again. One
// small request per check; the conversation is reloaded only when its number
// of messages or its newest message changed.
export const MESSAGES_POLL_MS = 10_000

export const messagesSignature = (firstPage: PaginatedResponse<Message>): string => {
  const newest = firstPage.data?.[0]
  return `${firstPage.metadata?.count}:${newest?.id}:${newest?.updatedAt}`
}

export const usePaginateMessages = (conversationId: string, options?: { live?: boolean }) => {
  return usePaginate<Message>(
    `messages-${conversationId}`,
    (params) => fetchMessages(conversationId, params),
    undefined,
    { pollMs: options?.live ? MESSAGES_POLL_MS : false, pollSignature: messagesSignature },
  )
}

